import "@/style.css";

import ErrorComponent from "@/components/Error";
import Screenshot from "@/components/Screenshot";
import Sidebar from "@/components/Sidebar";
import Video from "@/components/Video";
import { createScreenshotEvent } from "@/lib/events";
import { error, showSideBar, volume } from "@/state/config";
import { showScreenshotModal } from "@/state/recording";
import { render } from "preact";
import type { FunctionalComponent } from "preact";
import { useEffect } from "preact/hooks";

const App: FunctionalComponent = () => {
    let oldVolume = 0;

    const onKeyDown = (event: KeyboardEvent) => {
        if (event.key === "s" || event.key === "S") {
            if (showScreenshotModal.value) return;

            event.stopPropagation();
            window.dispatchEvent(createScreenshotEvent());
        }

        // Handle close / open sidebar
        if (event.key === "c" || event.key === "C" || event.key === "Escape") {
            if (showScreenshotModal.value) return;

            event.stopPropagation();
            showSideBar.value = !showSideBar.value;
        }

        // Handle mute / unmute
        if (event.key === "m" || event.key === "M") {
            if (volume.value === 0.0) {
                volume.value = oldVolume > 0 ? oldVolume : 1;
            } else {
                oldVolume = volume.value;
                volume.value = 0;
            }
        }
    };

    // Register keydown handler
    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        };
    });

    return (
        <div class="h-full w-full">
            {error.value && <ErrorComponent />}

            {!error.value && (
                <>
                    <Sidebar />

                    <Screenshot />

                    <div class="flex h-full w-full items-center justify-center align-middle">
                        <Video />
                    </div>
                </>
            )}
        </div>
    );
};

export default App;

const root = document.getElementById("root");
if (root) {
    render(<App />, root);
}
